import { forwardRef, useContext, useImperativeHandle, useRef } from "react";
import { LayoutContext } from "./context/layoutcontext";

const AppTopbar = forwardRef((props, ref) => {
    const { onMenuToggle, showProfileSidebar } = useContext(LayoutContext);
    const menubuttonRef = useRef(null);

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current
    }));

    return (
        <div className="layout-topbar">
            <div className="topbar-start">
                <button ref={menubuttonRef} type="button" className="topbar-menubutton p-link p-trigger" onClick={onMenuToggle}>
                    <i className="pi pi-bars" />
                </button>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-profile">
                        <button type="button" className="p-link" onClick={showProfileSidebar}>
                            <i className="pi pi-fw pi-user" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
});
AppTopbar.displayName = "AppTopbar";

export default AppTopbar;
